import { CreateEmployeeComponent } from './create-employee/create-employee.component';
import { EditEmployeeComponent } from './edit-employee/edit-employee.component';
import { SingleViewEmployeeComponent } from './viewemployees/single-view-employee.component';
import { ViewemployeesComponent } from './viewemployees/viewemployees.component';
import { EventEmployeeComponent} from './event-employee/event-employee.component';

export const EmployeeDetailsRouting = [
    { path: '', redirectTo: 'view-employee', pathMatch: 'full' },
    { path: 'add-employee', component: CreateEmployeeComponent },
    { path: 'view-employee', component: ViewemployeesComponent },
    { path: 'single-view-employee/:employeeID', component: SingleViewEmployeeComponent },
    { path: 'edit-employee/:employeeID', component: EditEmployeeComponent },
    {path:'event-employee',component:EventEmployeeComponent}
];

export const EmployeeDetailsRoutingBreadcrumbs = [
    { name: 'Single-view',path:'/single-view-employee' },
    { name: 'Edit', path: '/edit-employee' },
    { name: 'Add', path: '/add-employee' },

];